import Container from './Container';
import Item from './Item';

export default Object.assign(Container, {
  Item,
});
